{
  "CSServiceForms": {
    "wizard": {
      "steps": {
        "claimType": {
          "disabled": "Only one compensation regulation can be selected at a time.",
          "required": "Please select an option."
        }
      }
    }
  },
  "NTServiceForms": {
    "fields": {
      "cpapDeviceBatteryOption": {
        "label": "Do you have your own battery for your CPAP device?",
        "required": "Please pick an option.",
        "cpapDeviceBatteryNo": "No",
        "cpapDeviceBatteryYes": "Yes"
      },
      "cpapDeviceBatteryDetails": {
        "label": "Please share the battery’s power capacity in Watt-hours (Wh).",
        "required": "This field is required."
      },
      "cpapDeviceModel": {
        "label": "Make and model",
        "required": "Make and model are required."
      },
      "medicalEquipment": {
        "cpapDevice": "CPAP device (If not used during flight, airline approval not required. If used for treating sleep apnea, MEDIF not required)"
      }
    },
    "specialAssistanceForm": {
      "cpapNoBatteryDisclaimer": "<p>As we cannot guarantee electrical power during the flight, please ensure that you can manage without your device during the flight if necessary.</p>"
    }
  }
}
